import { Action, createReducer, on } from '@ngrx/store';

import { Post } from '@planone/bau365/util-fair-data';

import * as DataAccessPostsActions from './data-access-posts.actions';

import * as DataAccessExhibitorsActions from '../../exhibitors/entity/data-access-exhibitors.actions';

export const DATA_ACCESS_POSTS_FEATURE_KEY = 'dataAccessPosts';

export interface PostsState {
  activePostLoading?: boolean;
  activePostError?: string;
  posts: KeyedPostsState;
}

interface KeyedPostsState {
  [id: string]: Post;
}

export interface DataAccessPostsPartialState {
  readonly [DATA_ACCESS_POSTS_FEATURE_KEY]: PostsState;
}

export const initialPostsState: PostsState = {
  posts: {},
};

const dataAccessPostsReducer = createReducer(
  initialPostsState,
  on(DataAccessPostsActions.postOpened, (state, { postId }) => {
    const loaded = typeof state.posts[postId] !== 'undefined';

    return {
      ...state,
      activePostLoading: !loaded,
      activePostError: undefined,
    };
  }),
  on(DataAccessPostsActions.postLoadSucceeded, (state, { post }) => ({
    ...state,
    activePostError: undefined,
    activePostLoading: false,
    posts: {
      ...state.posts,
      [post.id]: post,
    },
  })),
  on(DataAccessPostsActions.postLoadFailed, (state, { error }) => ({
    ...state,
    activePostLoading: false,
    activePostError: error,
  })),
  on(
    DataAccessExhibitorsActions.exhibitorPostsLoadNext,
    DataAccessExhibitorsActions.exhibitorPostsLoadSucceeded,
    (state, { exhibitorPostsResponse }) => {
      let object = {};

      exhibitorPostsResponse.items.forEach(
        (post) =>
          (object = {
            ...object,
            [post.id]: post,
          })
      );

      return {
        ...state,
        posts: {
          ...state.posts,
          ...object,
        },
      };
    }
  )
);

export function postsReducer(state: PostsState | undefined, action: Action) {
  return dataAccessPostsReducer(state, action);
}
